// src/layouts/certificaciones/certificate/generatePdf.js
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import React from "react";
import { createRoot } from "react-dom/client";
import CertificateWithImages from "./CertificateWithImages";

/**
 * Renderiza off-screen la plantilla con imágenes y descarga un PDF A4.
 */
export async function buildAndDownloadCertificatePdf(cert, filename = "certificado.pdf", selloNombre) {
  // 1) Contenedor fuera de la vista
  const host = document.createElement("div");
  host.style.position = "fixed";
  host.style.left = "-10000px";
  host.style.top = "0";
  host.style.width = "794px";
  host.style.height = "1123px";
  document.body.appendChild(host);

  const root = createRoot(host);
  root.render(<CertificateWithImages cert={cert} selloNombre={selloNombre} />);

  // Espera 1 frame para montar
  await new Promise((r) => requestAnimationFrame(r));

  // 2) Captura a doble escala para nitidez
  const canvas = await html2canvas(host, { scale: 2, backgroundColor: null, useCORS: true });
  const img = canvas.toDataURL("image/png");

  // 3) Inserta en PDF A4
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfW = 210;
  const pdfH = (canvas.height / canvas.width) * pdfW;
  pdf.addImage(img, "PNG", 0, 0, pdfW, pdfH);
  pdf.save(filename);

  // 4) Limpieza
  root.unmount();
  host.remove();
}
